/* eslint-disable no-undef */
/* eslint-disable import/no-anonymous-default-export */

export default (editor, opts = {}) => {
    const dc = editor.DomComponents;
    const defaultType = dc.getType('default');
    const defaultView = defaultType.view;
    const styles = `
      .swiper-container {
        width: 600px;
        height: 300px;
      }
      .swiper-slide {
        text-align: center;
        font-size: 18px;
        background: #fff;

        /* Center slide text vertically */
        display: -webkit-box;
        display: -ms-flexbox;
        display: -webkit-flex;
        display: flex;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        -webkit-justify-content: center;
        justify-content: center;
        -webkit-box-align: center;
        -ms-flex-align: center;
        -webkit-align-items: center;
        align-items: center;
      }

      .swiper-slide img {
        display: block;
        width: 100%;
        height: 100%;
        object-fit: cover;
      }`;

    dc.addType(opts.name, {
        model: {
            defaults: {
                traits: [{
                        type: 'checkbox',
                        name: 'dynamicProgress',
                        label: 'Dynamic Progress',
                        changeProp: 1,
                    },
                    {
                        type: 'number',
                        name: 'sapceBetween',
                        label: 'Space Between',
                        changeProp: 1,
                    },
                    {
                        type: 'select',
                        name: 'progressType',
                        label: 'Progress Type',
                        changeProp: 1,
                        options: [
                            { value: 'bullets', name: 'Bullets' },
                            { value: 'fraction', name: 'Fraction' },
                            { value: 'progressbar', name: 'Progressbar' },
                        ],
                    },
                ],
                script: function() {
                    const dynamicProgress = '{[ dynamicProgress ]}';
                    const sapceBetween = '{[ sapceBetween ]}';
                    const progressType = '{[ progressType ]}';

                    const initLib = function() {
                        swiper = new Swiper('.mySwiper', {
                            spaceBetween: parseInt(sapceBetween) || 0,
                            centeredSlides: true,
                            resistance: true,
                            resistanceRatio: 0.25,
                            pagination: {
                                el: '.swiper-pagination',
                                clickable: true,
                                dynamicBullets: !!dynamicProgress,
                                type: progressType,
                            },
                            navigation: {
                                nextEl: '.swiper-button-next',
                                prevEl: '.swiper-button-prev',
                            },
                        });
                        swiper.on('touchStart', function() {

                        });

                        swiper.on('touchEnd', function(event) {
                            var touchEndX = event.touches.currentX;
                            var touchEndY = event.touches.currentY;
                            var diffX = event.touches.startX - touchEndX;
                            var diffY = event.touches.startY - touchEndY;
                            if (Math.abs(diffX) > Math.abs(diffY)) {
                                if (diffX > 0) {
                                    // console.log('Swiped left');

                                    // console.log('Swiped right');
                                    let nextSlide_attr = $('#wrapper').attr('next-key-message');
                                    if (
                                        swiper.activeIndex + 1 == swiper.slides.length &&
                                        swiper.touches.diff < 0
                                    ) {
                                        if (typeof com !== 'undefined') {
                                            if (
                                                nextSlide_attr != undefined &&
                                                nextSlide_attr.trim() != ''
                                            ) {
                                                console.log('Keymessage-name: ' + nextSlide_attr);
                                                com.veeva.clm.runAPIRequest(
                                                    `veeva:gotoSlide(` + nextSlide_attr + `)`
                                                );
                                            } else {
                                                console.log('Next-slide');
                                                com.veeva.clm.runAPIRequest(`veeva:nextSlide()`);
                                            }
                                        }
                                    }
                                } else {
                                    let prevSlide_attr = $('#wrapper').attr('prev-key-message');
                                    if (swiper.activeIndex == 0 && swiper.touches.diff > 0) {
                                        if (typeof com !== 'undefined') {
                                            if (
                                                prevSlide_attr != undefined &&
                                                prevSlide_attr.trim() != ''
                                            ) {
                                                console.log('Keymessage-name: ' + prevSlide_attr);
                                                com.veeva.clm.runAPIRequest(
                                                    `veeva:gotoSlide(` + prevSlide_attr + `)`
                                                );
                                            } else {
                                                console.log('Previous-slide');
                                                com.veeva.clm.runAPIRequest(`veeva:prevSlide()`);
                                            }
                                        }
                                    }
                                }
                            } else {
                                if (diffY > 0) {
                                    // console.log('Swiped up');
                                } else {
                                    // console.log('Swiped down');
                                }
                            }
                            // Reset values
                            this.touchStartX = null;
                            this.touchStartY = null;
                        });

                        console.log('swiper :>> ', swiper);
                    };

                    if (typeof Swiper == 'undefined') {
                        const script = document.createElement('script');
                        script.onload = initLib;
                        script.src = 'https://unpkg.com/swiper@7/swiper-bundle.min.js';
                        document.body.appendChild(script);
                    } else {
                        initLib();
                    }
                },
                styles: styles
            },
        },

        isComponent: (el) => {
            if (el.className && el.className.includes('swiper-container')) {
                return {
                    type: opts.name,
                };
            }
        },

        view: defaultView.extend({
            init({ model }) {
                this.listenTo(model, 'change:dynamicProgress', this.updateScript);
                this.listenTo(model, 'change:progressType', this.updateScript);
                this.listenTo(model, 'change:sapceBetween', this.updateScript);
            },
        }),
    });
};